import { EventEmitter, Input, OnChanges, Output, SimpleChanges, Directive } from '@angular/core';

import { isEmptyValue } from '@helpers';
import { ApplicationUtilsService } from '@util-services';

@Directive()
export class EcertBaseBlockComponent implements OnChanges {
  @Input() ref_object;
  @Input() property: string;
  @Input() vulAutomatisch = true;
  protected ref_objectPostCheck: () => void = null;

  @Input() tooltip: string;
  @Input() container_class: string;
  protected _placeholder: string;
  @Input()
  set placeholder(placeholder: string) {
    this._placeholder = placeholder;
  }
  get placeholder(): string {
    return this._placeholder;
  }
  @Input() action_identifier: string;

  @Input() hideLabel = false;

  @Input() error = false;
  @Input() foutmelding: string;
  @Input() toonErrors = false;

  protected _label: string = null;
  @Input()
  set label(label: string) {
    this._label = label;
  }
  get label(): string {
    if (this._label === null && !this.hideLabel) {
      // Als er geen label wordt meegegeven, haal de prompt van de gegeven action identifier
      return this.appUtils.getPrompt(this.action_identifier);
    } else {
      return this._label;
    }
  }

  protected _disabled = false;
  @Input()
  set disabled(disabled: boolean) {
    this._disabled = disabled;
  }
  get disabled(): boolean {
    if (isEmptyValue(this.ref_object) || isEmptyValue(this.ref_object.muteerbaar)) {
      return this._disabled;
    } else {
      return this._disabled || !this.ref_object.muteerbaar || (this.ref_object.eedOpSlot && !this.wijzigbaar);
    }
  }

  @Input() inline = false;

  protected _wijzigbaar = false;
  @Input()
  set wijzigbaar(wijzigbaar: boolean) {
    this._wijzigbaar = wijzigbaar;
  }
  get wijzigbaar(): boolean {
    if (this.action_identifier === undefined) {
      return this._wijzigbaar;
    }
    return this.appUtils.getKolomActie(this.action_identifier, 'wijzigbaar') || this._wijzigbaar;
  }

  @Input() required: boolean;

  get verplicht(): boolean {
    return false;
    if (isEmptyValue(this.required)) {
      return this.appUtils.getKolomActie(this.action_identifier, 'verplicht');
    } else {
      return this.required;
    }
  }

  @Output() valueChange = new EventEmitter();

  constructor(protected appUtils: ApplicationUtilsService) {}

  ngOnChanges({ ref_object, property, vulAutomatisch }: SimpleChanges): void {
    if (!!ref_object || !!property || !!vulAutomatisch) {
      if (!isEmptyValue(this.ref_object) && !isEmptyValue(this.ref_objectPostCheck)) {
        this.ref_objectPostCheck();
      }
    }
  }

  componentChanged(adres) {
    this.valueChange.emit(adres);
  }

  hasErrors() {
    console.error('hasErrors is voor dit component niet gedefinieerd');
    return false;
  }

  protected getWaarde(): string {
    if (isEmptyValue(this.ref_object) || isEmptyValue(this.property)) {
      return '';
    }
    return this.ref_object[this.property];
  }
}
